export default __webpack_public_path__ + "static/media/mango1.c964002e.png";